import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Footer.css';
import colegio from '../Images/colegio.png';
import Isak from '../Images/Isak.png';
import logo from '../Images/Logo.png';

const TikTokIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    height="1em"
    width="1em"
  >
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
  </svg>
);

const Footer = ({ scrollToSection }) => {
  return (
    <div className="footer-wrapper">
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <img src={logo} alt="Nut. Mayra Alejandra Martell" className="footer-logo" />
              <h3>Nut. Mayra Alejandra Martell</h3>
              <p>Nutricionista Colegiada CNP 9331</p>
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=100028246129126" target="_blank" rel="noopener noreferrer" className="social-link">
                  <Facebook />
                </a>
                <a href="https://www.instagram.com/nutri__mayramartell/profilecard/?igsh=MW1zZ3FicHptbDc4OA==" target="_blank" rel="noopener noreferrer" className="social-link">
                  <Instagram />
                </a>
                <a href="https://www.tiktok.com/@nutri_mayramartell?lang=es" target="_blank" rel="noopener noreferrer" className="social-link">
                  <TikTokIcon />
                </a>
                <a href="https://www.youtube.com/@nutrimayramartell" target="_blank" rel="noopener noreferrer" className="social-link">
                  <Youtube />
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h4>Enlaces Rápidos</h4>
              <a href="#inicio" onClick={(e) => scrollToSection(e, 'inicio')}>Inicio</a>
              <a href="#sobre-mi" onClick={(e) => scrollToSection(e, 'sobre-mi')}>Sobre Mí</a>
              <a href="#nutrishop" onClick={(e) => scrollToSection(e, 'nutrishop')}>NutriShop</a>
              <a href="#testimonios" onClick={(e) => scrollToSection(e, 'testimonios')}>Testimonios</a>
            </div>

            <div className="footer-contact">
              <h4>Contacto</h4>
              <div className="contact-info">
                <p><Phone className="contact-icon" /> +51 923 651 512</p>
                <p><Mail className="contact-icon" /> martellllantoym@gmail.com</p>
                <p>
                  <MapPin className="contact-icon" />
                  <span>Calle Bernini 352, San Borja, Perú</span>
                </p>
                <div className="horarios">
                  <p><Clock className="contact-icon" /> Horarios de Atención:</p>
                  <p className="horario-detalle">Lunes a Viernes: 8:00 AM - 8:00 PM</p>
                  <p className="horario-detalle">Sábado: 8:00 AM - 1:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Mapa */}
          <div className="footer-map">
            <h4>Encuéntranos</h4>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3901.3087524869976!2d-76.99447892408573!3d-12.095644188142982!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c7cf8e0a5a7d%3A0x7e0e0e0e0e0e0e0e!2sCalle%20Bernini%20352%2C%20San%20Borja%2C%20Lima%2C%20Per%C3%BA!5e0!3m2!1ses!2spe!4v1234567890123!5m2!1ses!2spe"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación Consultorio"
              ></iframe>
            </div>
          </div>

          <div className="footer-credentials">
            <div className="credentials-list">
              <a
                href="https://www.cnp.org.pe/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={colegio} alt="Colegio de Nutricionistas del Perú" className="credential-logo" />
              </a>
              <img src={Isak} alt="Otras Certificaciones" className="credential-logo" />
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Nut. Mayra Alejandra Martell. Todos los derechos reservados.</p>
            <div className="footer-legal">
              <Link to="/politicas" target="_blank">Política de Privacidad</Link>
              <Link to="/terminos" target="_blank">Términos y Condiciones</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;